import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { RouteHandlerService } from '../services/route-handler.service';
import { environment } from '../../../environments/environment';

export const ensureEventSlugGuard: CanActivateFn = () => {
    const routeHandler = inject(RouteHandlerService);

    if (routeHandler.HostName === environment.paymentHost) {
        return false;
    }
    if (routeHandler.isExternalCustomDomain() && routeHandler.hasEventSlugInPath()) {
        return false;
    }
    if (routeHandler.isBaseDomainSubdomain()) {
        routeHandler.cacheSubdomainSlug();
        return true;
    }
    if (routeHandler.getCachedEventSlug()) {
        return true;
    }

    return routeHandler.fetchAndCacheEventSlug().pipe(
        map((slug) => !!slug),
        catchError(() => of(false))
    );
};
